import { CustomizableValidator } from '../../types/Validator';

const errorCode = 'MISS_MATCHED';

interface MatchProps {
  regexp: RegExp;
}

const match: CustomizableValidator<MatchProps> = ({
  regexp,
  variables
}) => value => {
  if (regexp) {
    const result = String(value).match(regexp);
    if (!result) {
      const error = {
        errorCode,
        params: variables
      };
      return error;
    }
  }
};

export { match, errorCode };
